module.exports = __webpack_public_path__ + "static/media/bg_02.2f52bc7d.jpg";